import React from 'react';

export type SidebarTheme = {
  sidebarTextColor: string;
  sidebarBackgroundColor: string;
  sidebarItemHoverBackground: string;
  /** When true, items use client theme styles even if the user is internal. */
  isClientPreview?: boolean;
};
export const SidebarThemeContext = React.createContext<SidebarTheme>({
  sidebarTextColor: '',
  sidebarBackgroundColor: '',
  sidebarItemHoverBackground: '',
});
